module.exports = __webpack_public_path__ + "img/open-modal.b5a797a7.svg";